import { INPUT_CLASS, LABEL_CLASS } from '@/components/common/node-view-settings-panel';
import { MaImageUsageBadge } from '@/components/image-library/ma-image-usage-warning';
import { useMaImageUsages } from '@/components/image-library/use-ma-image-usages';
import { Textarea } from '@/components/ui/textarea';

interface ImageEditAltTextFieldsProps {
    maImageId?: number | null;
    alt: string | null;
    onAltChange: (alt: string | null) => void;
    previewSrc: string;
    previewAlt?: string | null;
    showPreview?: boolean;
    enabled?: boolean;
    currentMaDocumentId?: number | null;
}

export function ImageEditAltTextFields({
    maImageId,
    alt,
    onAltChange,
    previewSrc,
    previewAlt,
    showPreview = true,
    enabled = true,
    currentMaDocumentId,
}: ImageEditAltTextFieldsProps) {
    const { usages, loading, error } = useMaImageUsages(maImageId, enabled);
    const showUsageBadge = typeof maImageId === 'number' && maImageId > 0;

    return (
        <div className="flex flex-col gap-3">
            {showPreview ? (
                <div className="image-preview">
                    <img
                        src={previewSrc}
                        alt={previewAlt ?? ''}
                    />
                </div>
            ) : null}

            <div>
                <div className={`${LABEL_CLASS} flex items-center gap-2`}>
                    <label htmlFor="alt">Alt Text</label>
                    {showUsageBadge ? (
                        <span className="mb-1">
                            <MaImageUsageBadge
                                usages={usages}
                                loading={loading}
                                error={error}
                                currentMaDocumentId={currentMaDocumentId}
                            />
                        </span>
                    ) : null}
                </div>
                <Textarea
                    id="alt"
                    className={`${INPUT_CLASS} ${alt ? '' : 'border-2 border-red-500'}`}
                    value={alt ?? ''}
                    onChange={e => onAltChange(e.target.value === '' ? null : e.target.value)}
                    required
                />
            </div>
        </div>
    );
}
